import React, { useEffect } from 'react'
import {
    IonButton,
    IonIcon,
    useIonAlert,
} from '@ionic/react'
import GoButton from './GoButton'
import EditButton from './EditButton'
import UndoRosterButton from './UndoRosterButton'
import {
    useCanEditItem,
	useAmClubAdmin,
    useEditModeState,
    useMyGame,
    useReady,
    useSettingsState,
    useShowPositionPreferencesState,
	useUser,
} from './data'
import { TiThSmallOutline } from 'react-icons/ti'
import { FaStreetView } from 'react-icons/fa'
import './controlbox.css'
import {informationCircleOutline} from 'ionicons/icons'

type ControlBoxProps = {
	haveSetPositions: boolean
	showAltBoard: boolean
	onToggleAltBoard: () => void
	onAutoRoster: () => void
	onStopAutoRoster: () => void
}

const ControlBox = (props: ControlBoxProps) => {

	const { haveSetPositions, showAltBoard, onToggleAltBoard, onAutoRoster, onStopAutoRoster } = props

    const [ editMode, setEditMode ] = useEditModeState()
    const canEditItem = useCanEditItem()
    const ready = useReady()
    const game = useMyGame()
    const [ settings ] = useSettingsState()

    const [ showPositionPreferences, setShowPositionPreferences ] = useShowPositionPreferencesState()

    const [ presentAlert ] = useIonAlert()

	useEffect(() => {
		if (editMode && !canEditItem) {
			setEditMode(false)
			setShowPositionPreferences(false)
		}
	}, [ editMode, canEditItem, setEditMode, setShowPositionPreferences ])

    /*
	const onPrint = e => {
		if (showPositionPreferences) {
			onTogglePositionPreferences()
			setTimeout(() => window.print(), 100)
		} else if (editMode) {
			onEdit()
			setTimeout(() => window.print(), 100)
		} else {
			window.print()
		}
	}
    */

	const onSetEditMode = (newValue: boolean) => {
		setEditMode(newValue)
		setShowPositionPreferences(false)
	}

    return (
        <div className="controlbox">

            <div className="controlbox-left">

                <EditButton
                    show={canEditItem}
                    ready={ready}
                    editMode={editMode}
					text={editMode ? 'Done' : undefined}
                    onClick={() => {
                        const isPastGame = game && game.date < Date.now()
                        if (isPastGame && !editMode) {
                            presentAlert({
                                header: 'Past Game',
                                message: 'This game is in the past. Are you sure you want to change the roster?',
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        role: 'cancel',
                                    },
                                    {
                                        text: 'Edit',
                                        role: 'confirm',
                                        handler: () => onSetEditMode(true),
                                    },
                                ],
                            })
                        } else {
                            onSetEditMode(!editMode)
                        }
                    }}
                />

				{ !canEditItem ? <WhyCantIEdit /> : null }

            </div>

            <div className="controlbox-center">

                <UndoRosterButton />

                <IonButton
                    className={
                        'button-preferences button-react-icon'
                        + (showPositionPreferences ? ' enabled' : '')
                        + (haveSetPositions ? ' have-set-positions' : '')
                        + (settings.preferenceType === 'Require' ? ' require-mode' : '')
                    }
                    onClick={() => setShowPositionPreferences(!showPositionPreferences)}
                    title="Set some required player positions"
                    color="light"
                >
                    <FaStreetView />
                    <span className="roster-button-text">
                        Positions
                    </span>
                </IonButton>

                <IonButton
                    className={'button-toggleview button-react-icon ' + (showAltBoard ? 'enabled' : '')}
                    onClick={onToggleAltBoard}
                    title="Change how you view the roster"
                    color="light"
                >
                    <TiThSmallOutline />
                    <span className="roster-button-text">
                        View
                    </span>
                </IonButton>

            </div>

	            <div className="controlbox-right">
	                <GoButton
	                    onAutoRoster={onAutoRoster}
						onStopAutoRoster={onStopAutoRoster}
	                />
	            </div>

        </div>
    )
}

const WhyCantIEdit = () => {

	const user = useUser()
	const amClubAdmin = useAmClubAdmin()

	const [ presentAlert ] = useIonAlert()

	const onClick = () => {
		console.log('uiser', user, 'why cant i edit?')
		let header
		let subHeader
		let message
		if (!user) {
			header = 'Not Logged In'
			message = "You must be logged in as the correct user to edit this roster."
		} else {
			header = "Account Doesn't Own Team"
			if (amClubAdmin) {
				subHeader = 'You are a club admin of this team, but not a coach.'
				message = 'This team is part of your club, but to edit its rosters, you must add yourself as its coach. Visit your club in your Profile, tap the team located beneath its current coach, then tap "+ Add Coach".'
			} else {
				subHeader = "Have you accidentally created two accounts?"
				message = "You're using an account that doesn't belong to this team. You might have created your team using one account (e.g. Sign In With Google), then later switched to a different one (e.g. phone number) without realising. Try signing out, then back in using the same account that created the team. See also: Help > Troubleshooting."
			}
		}
		presentAlert({
			header,
			subHeader,
			message,
			buttons: [ 'OK' ],
		})
	}

	return (
		<div
			className="why-cant-i-edit"
			onClick={onClick}
		>
			You can't edit this roster.
			<IonIcon
				className="more-info-link-icon"
				icon={informationCircleOutline}
			/>
		</div>
	)
}

export default ControlBox
